<script lang="ts">
  /**
   * Barre de réponse du Fil.
   *
   * Ce n'est volontairement pas un champ de saisie : un tap ouvre la feuille
   * Compose, qui a les destinataires, les pièces jointes, la signature et le
   * suivi d'ouverture. Un textarea inline ici obligeait à réimplémenter tout
   * ça en plus petit, et à choisir entre les deux au moment d'envoyer.
   */

  import { gmailState } from "../gmail/store.svelte";
  import { openReplyCompose } from "../gmail/compose";
  import Icon from "./shared/Icon.svelte";
  import { haptic } from "../gestures/haptic";

  interface Props {
    /** Prénom de l'interlocuteur, pour le libellé du champ. */
    recipient?: string;
  }
  let { recipient = "" }: Props = $props();

  function openReply() {
    const t = gmailState.currentThread;
    if (!t || t.messages.length === 0) return;
    haptic("light");
    openReplyCompose(t.messages[t.messages.length - 1], t.id);
  }
</script>

<div class="bar">
  <button class="field" onclick={openReply}>
    <Icon name="reply" size={16} />
    <span>Répondre{recipient ? ` à ${recipient}` : ""}…</span>
  </button>
  <button class="send" onclick={openReply} aria-label="Répondre">
    <Icon name="forward" size={17} />
  </button>
</div>

<style>
  .bar {
    position: fixed;
    left: 0;
    right: 0;
    /* Au-dessus de la tab bar, qui reste visible sur le fil. */
    bottom: calc(env(safe-area-inset-bottom) + 52px);
    z-index: 18;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px 12px;
    background: color-mix(in srgb, var(--bg) 92%, transparent);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    border-top: 1px solid var(--border-subtle);
  }

  .field {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 9px;
    height: 40px;
    padding: 0 13px;
    border: 1px solid var(--border);
    background: var(--bg-elev);
    border-radius: 20px;
    color: var(--fg-subtle);
    font-size: 13px;
    text-align: left;
  }
  .field span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .field:active { background: var(--bg-hover); }

  .send {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: var(--accent);
    color: var(--accent-fg);
  }
  .send:active { transform: scale(0.96); }
</style>
